import axios from 'axios'
export default {
  getListAll(params) {
    return new Promise((resolve, reject) => {
      axios
        .get("additional_off_day/index/all", {
          params: params
        })
        .then((res) => {
          resolve(res.data.data)
        })
        .catch(() => {
          reject('取得額外休息日錯誤')
        });
    })
  },
}